module.exports = __webpack_public_path__ + "img/bg-original.61d1a110.jpg";